export default "__VITE_ASSET__3bc2007a__"